module.exports = __webpack_public_path__ + "static/media/user.3036da3d.jpg";